import { captureException } from "@sentry/react";
import { broadcastQueryClient } from "@tanstack/query-broadcast-client-experimental";
import {
	MutationCache,
	QueryCache,
	QueryClient,
	type QueryClientConfig,
} from "@tanstack/react-query";

export const makeQueryClient = (config?: QueryClientConfig) => {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				retry: 0,
				staleTime: 5 * 1000,
			},
			mutations: {
				retry: 1,
			},
			...config?.defaultOptions,
		},
		queryCache:
			config?.queryCache ??
			new QueryCache({
				onError(error) {
					captureException(error);
				},
			}),
		mutationCache:
			config?.mutationCache ??
			new MutationCache({
				onError(error) {
					captureException(error);
				},
			}),
	});

	broadcastQueryClient({
		queryClient,
	});

	return queryClient;
};
